exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contract-pop{background:rgba(0,0,0,.8)!important;color:#fff;font-size:.213333rem!important;font-family:Arial!important;line-height:.346667rem!important;border-radius:.16rem!important}.contract-pop .popper__arrow,.contract-pop .popper__arrow:after{border-top-color:#000!important}", ""]);

// exports
